import { create } from 'zustand';
import type { Restrictions, SessionPayload, SessionUser, Site, Tenant } from '../lib/types';

export type AuthStatus = 'checking' | 'authenticated' | 'anonymous';

interface SessionState {
  status: AuthStatus;
  user: SessionUser | null;
  tenant: Tenant | null;
  site: Site | null;
  permissions: string[];
  restrictions: Restrictions | null;
  activeCompanyId: string | null;

  setSession(payload: SessionPayload): void;
  setActiveCompanyId(companyId: string): void;
  clear(): void;
  hasPermission(permission: string): boolean;
}

export const useSessionStore = create<SessionState>((set, get) => ({
  status: 'checking',
  user: null,
  tenant: null,
  site: null,
  permissions: [],
  restrictions: null,
  activeCompanyId: null,

  setSession(payload) {
    set({
      status: 'authenticated',
      user: payload.user,
      tenant: payload.tenant,
      site: payload.site,
      permissions: payload.permissions,
      restrictions: payload.restrictions,
      activeCompanyId: payload.activeCompanyId,
    });
  },

  setActiveCompanyId(companyId) {
    set({ activeCompanyId: companyId });
  },

  clear() {
    set({
      status: 'anonymous',
      user: null,
      tenant: null,
      site: null,
      permissions: [],
      restrictions: null,
      activeCompanyId: null,
    });
  },

  hasPermission(permission) {
    // Usability gate only — see lib/permissions.ts for the loud version of
    // this comment. The server re-checks every one of these on every call.
    return get().permissions.includes(permission);
  },
}));
